import script from "./insertFiles.vue?vue&type=script&setup=true&lang=js"
export * from "./insertFiles.vue?vue&type=script&setup=true&lang=js"

import "./insertFiles.vue?vue&type=style&index=0&id=77b9d30d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77b9d30d"]])

export default __exports__